import { DynamicModal } from "src/components/base/components/DynamicModal";
import { createState } from "src/utils/create_zustand_store";
import { useRouterExt } from "../../reusable/hooks/useRouterExt";
import { Box } from "@mui/material";

export const useCheckoutErrorModal = createState({
  isOpen: false,
  errorMessage: "",
});

export function CheckoutErrorModal() {
  const router = useRouterExt();
  const modalState = useCheckoutErrorModal();

  const onClose = () => {
    modalState.reset();
  };

  return (
    <DynamicModal
      isOpen={modalState.isOpen}
      title="Error"
      description={<Box py={1}>{modalState.errorMessage}</Box>}
      onClose={onClose}
      slot={{
        primaryButton: {
          label: "Close",
          onClick: () => onClose(),
        },
        secondaryButton: {
          isHidden: true,
        },
      }}
    />
  );
}
